import { useContext, useRef } from "react";
import { Redirect } from "react-router-dom";
import { Button, Tooltip } from "antd";
import { FiAlertCircle, FiX } from "react-icons/fi";
import { FileIcon, defaultStyles } from "react-file-icon";
import Compressor from "compressorjs";

import DocumentationContext from "../../store/documentation-context";

import classes from "./file-list.module.scss";

const FileList = () => {
  const fileRef = useRef();

  const documentationCtx = useContext(DocumentationContext);

  const onUpload = () => {
    fileRef.current.click();
  };

  const parseSize = (size) => {
    var i = Math.floor(Math.log(size) / Math.log(1024));
    return (
      (size / Math.pow(1024, i)).toFixed(2) * 1 +
      " " +
      ["B", "KB", "MB", "GB", "TB"][i]
    );
  };

  const isImage = (file) => {
    return file["type"].split("/")[0] === "image";
  };

  const compressImage = (file) => {
    return new Promise((resolve, reject) => {
      new Compressor(file, {
        quality: 0.6,
        success(result) {
          resolve(result);
        },
        error(err) {
          reject(err);
        },
      });
    });
  };

  const readFile = async (file) => {
    return new Promise((resolve) => {
      let reader = new FileReader();
      reader.onload = (e) => resolve(reader.result.split(",")[1]);
      reader.readAsDataURL(file);
    });
  };

  const onChange = async (event) => {
    const list = event.currentTarget.files;

    if (list.length === 0) {
      return;
    }

    let nFiles = [...documentationCtx.archivos];

    for (let i = 0; i < list.length; i++) {
      let file = list[i];

      if (isImage(file)) {
        file = await compressImage(file);
      }

      let nFile = {};
      nFile.name = file.name;
      nFile.type = file.type;
      nFile.size = file.size;
      nFile.extension = file.name.split(".").pop();
      nFile.filesize = parseSize(file.size);
      nFile.content = await readFile(file);
      nFile.exceeded = file.size > 10000000;
      nFiles.push(nFile);
    }

    documentationCtx.updateArchivos(nFiles);
    event.target.value = "";
  };

  const onDelete = (index) => {
    const nFiles = [...documentationCtx.archivos];
    nFiles.splice(index, 1);
    documentationCtx.updateArchivos(nFiles);
  };

  if (!documentationCtx.numero) {
    return <Redirect to="/" />;
  }

  return (
    <div className={classes.list}>
      {documentationCtx.archivos.map((file, index) => (
        <div className={classes.file} key={index}>
          <div className={classes.icon}>
            <FileIcon
              extension={file.extension}
              {...defaultStyles[file.extension]}
            />
          </div>
          <div className={classes.data}>
            <div className={classes.name}>{file.name}</div>
            <div className={classes.size}>
              {file.filesize}
              {file.exceeded && (
                <Tooltip title="Tamaño máximo excedido">
                  <FiAlertCircle className={classes.warning} />
                </Tooltip>
              )}
            </div>
          </div>
          <div className={classes.actions}>
            <div className={classes.delete} onClick={() => onDelete(index)}>
              <FiX />
            </div>
          </div>
        </div>
      ))}

      <div
        className={`${classes.add} ${
          documentationCtx.archivos.length === 0 ? classes.full : ""
        }`}
      >
        <Button type="primary" onClick={onUpload}>
          Agregar
        </Button>
        <input type="file" multiple ref={fileRef} onChange={onChange} />
        <div className={classes.description}>
          Cada archivo no puede pesar más de 10 MB
        </div>
      </div>
    </div>
  );
};

export default FileList;
